import { Injectable, ErrorHandler } from '@angular/core';
import { ErrorLogService } from './error-log.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService extends ErrorHandler {

  constructor(private errorLogService: ErrorLogService) {
    super();
  }

  handleError(error) {
    console.error(error);
    this.errorLogService.logError(error);
  }

}
